import { z } from 'zod';
import { listQuerySchema } from '../common/pagination';
import { safeFileNameSchema, versionResponseSchema } from './upload.schema';

/** Listen-Query für Dokumente: Pagination + optionaler Ordner-/Entitäts-Filter. */
export const documentListQuerySchema = listQuerySchema.extend({
  folderId: z.string().uuid().optional(),
  projectId: z.string().uuid().optional(),
  customerId: z.string().uuid().optional(),
});
export type DocumentListQuery = z.infer<typeof documentListQuerySchema>;

/** Umbenennen und/oder Verschieben (neuer Ordner). */
export const updateDocumentSchema = z.object({
  name: safeFileNameSchema.optional(),
  folderId: z.string().uuid().optional(),
});
export type UpdateDocumentInput = z.infer<typeof updateDocumentSchema>;

/** Datei kopieren — optional in einen anderen Ordner (Default: gleicher Ordner). */
export const copyDocumentSchema = z.object({
  folderId: z.string().uuid().optional(),
});
export type CopyDocumentInput = z.infer<typeof copyDocumentSchema>;

export const documentResponseSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  folderId: z.string().uuid(),
  name: z.string(),
  projectId: z.string().uuid().nullable(),
  customerId: z.string().uuid().nullable(),
  /** Aktuelle Version (Metadaten); null, solange noch kein Upload committet wurde. */
  currentVersion: versionResponseSchema.nullable(),
  versionCount: z.number().int(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type DocumentResponse = z.infer<typeof documentResponseSchema>;
